import React, { PropTypes, Component } from 'react';
import playable from '@alias/Playable';
import { dateFormat } from 'lib/format';
import { SortOrder } from 'enums';

const headerMappings = [
    {
        keyType: 'Date',
        value: 'startTime'
    },
    {
        keyType: 'Title',
        value: 'name'
    },
    {
        keyType: 'Sport',
        value: 'sport'
    },
    {
        keyType: 'League',
        value: 'league'
    },
    {
        keyType: 'Network',
        value: 'network'
    },
    {
        keyType: 'Link',
        value: 'link'
    }
];

function sortByDateDescending(c1, c2) {
    return new Date(c2.utc) - new Date(c1.utc);
}

function getSearchResultList(content = {}) {
    const stream = content.streams.find((el) => (el.links && el.links.web));
    const displayTime = content.utc && dateFormat.dateFormat(content.utc, 'dateTime7');
    return {
        displayTime,
        name: content.name,
        sport: content.programmingData.sport,
        league: content.programmingData.league,
        network: stream.source.name,
        link: stream.links.web
    };
}

function copyToClipboard(copiedText) {
    const clipboardElement = document.createElement('input');
    document.body.appendChild(clipboardElement);
    clipboardElement.setAttribute('value', copiedText);
    clipboardElement.select();
    document.execCommand('copy');
    document.body.removeChild(clipboardElement);
}

class SearchResultAsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortBy: 'Date',
            sortOrder: SortOrder.DESC
        };
    }

    clickHeader(index) {
        let { sortBy, sortOrder } = this.state;
        const { keyType } = headerMappings[index];
        if (keyType === this.state.sortBy) {
            sortOrder = (this.state.sortOrder === SortOrder.DESC) ? SortOrder.ASC : SortOrder.DESC;
        } else {
            sortBy = keyType;
            sortOrder = SortOrder.DESC;
        }
        this.setState({
            sortBy,
            sortOrder
        });
        this.props.sortContents(headerMappings[index].value, sortOrder);
    }

    render() {
        const headerRows = headerMappings.map((headerMapping, index) => (
            <th onClick={() => this.clickHeader(index)}>{headerMapping.keyType}</th>
        ));
        const header = (<tr>{headerRows}</tr>);
        const rows = this.props.contents.sort(sortByDateDescending).map((content) => {
            const searchResultListing = getSearchResultList(content);
            return (
                <tr key={`tr_${content.id}`}>
                    <td className="schedule__time">{searchResultListing.displayTime}</td>
                    <td className="schedule__time">{searchResultListing.name}</td>
                    <td className="schedule__time">{searchResultListing.sport}</td>
                    <td className="schedule__time">{searchResultListing.league}</td>
                    <td className="schedule__network">{searchResultListing.network}</td>
                    <td className="schedule__competitors">
                        <button onClick={() => { copyToClipboard(searchResultListing.link); }}>Copy Event Link</button>
                    </td>
                </tr>
            );
        });
        return (
            <table>
                <thead>
                    {header}
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        );
    }
}

SearchResultAsList.propTypes = {
    contents: PropTypes.array,
    sortContents: PropTypes.func
};

export default playable(SearchResultAsList);
export { SearchResultAsList as BaseSearchResultAsList };



// WEBPACK FOOTER //
// ./app/common/search/SearchResultAsList.js